{{#each profile}}
	{{#if show}}
		<li>
			<a class="{{class}}" href="{{url}}">
				<i class="{{icon}} m-r-5"></i> {{{text}}}
			</a>
		</li>
		{{#if hasDevider}}
		<li>
			<div class="divider"></div>
		</li>
		{{/if}}
	{{/if}}
{{/each}}
